const resetCreatePOField = () => ({
  type: 'RESET_CREATE_PO_FIELD',
})

export { resetCreatePOField }
